const token = {
  colorPrimary: process.env.REACT_APP_PRIMARY_COLOR || "#a224e9",
  colorSuccess: "#64a45a",
  colorBgLayout: "#3e3e3f",
  colorBgMask: "rgba(0, 0, 0, 0.3)",
  borderRadius: 3,
}

export default token
